import { render } from "./TablaFerreteria.vue?vue&type=template&id=1cbb5d6e&scoped=true"
import script from "./TablaFerreteria.vue?vue&type=script&lang=js"
export * from "./TablaFerreteria.vue?vue&type=script&lang=js"

import "./TablaFerreteria.vue?vue&type=style&index=0&id=1cbb5d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbb5d6e"]])

export default __exports__